module.exports = __webpack_public_path__ + "static/media/sch-4.1453412b.jpg";